import React, { ReactElement } from 'react';
import { RecoveryWrapper } from '../../features/auth/RecoveryWrapper';

interface ContentProps {}

function Content({}: ContentProps): ReactElement {
  return <RecoveryWrapper />;
}

export { Content };
